<div class="modal-header">
  <h4 class="modal-title" id="period-modal-title">
      {{headerTitle}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss(false)" tabindex="-1">
    <!-- <i class="fa fa-times fa-sm fa-fw"></i> -->
  </button>
</div>

<div class="modal-body"  [innerHTML]="modalMessage"> 
</div>

